export const listTaskTemplates = `
query {
  taskTemplates {
    id
    name
    taskType
    isDefault
    defaultDueTime
  }
}
`;

export interface TaskTemplateType {
  id: string;
  name: string;
  taskType: 'appointment' | 'todo';
  isDefault: boolean;
  defaultDueTime: number;
}

export interface TaskTemplateListType {
  taskTemplates: TaskTemplateType[];
}
